import React from 'react'

const ParticipantItemIconsWithFallBack = ({ className, alt, src }) => {


    if (src.includes("/0.png")) { // Empty, not missing
        // src = process.env.PUBLIC_URL + `/assets/empty_icons/0.png`
        return (<div className="h-[18px] w-[18px] rounded-md bg-zinc-800"></div>)
    }

    function handleError(e) {
        // e.target.src = process.env.PUBLIC_URL + `/assets/profile_icons/0.png`
        e.target.src = process.env.PUBLIC_URL + `/assets/missing_asset/missing_icon.png`
    }
    return (
        <img
            className={className}
            src={src}
            alt={alt}
            onError={(e) => handleError(e)}
        />
    )
}

export default ParticipantItemIconsWithFallBack
